import ServicesSection from "../../components/Home/ServicesSection";
import SuccessStories from "../../components/Stories/SuccessStories";
import AnimatedPage from "../../components/ui/AnimatePage";
import HomeService from "../../components/Service/Home";
import Container from "../../components/ui/Container";
import { motion, useAnimationControls } from "framer-motion";
import { useEffect } from "react";
import { useIntroContext } from "../../hooks/useIntroContext";
import BlogsSection from "../../components/Blogs/BlogSection";

const Home: React.FC = () => {
  const contentControls = useAnimationControls();


  useEffect(() => {
    contentControls.start({
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] },
    });
  }, []);

  return (
    <>
      <Container>
        <HomeService />
      </Container>

      <ServicesSection />
      <SuccessStories />
      <BlogsSection/>
    </>
  );
};

export default Home;
